export default {
    loginAs: "Login as...",
    signUp: "Signup",
    signInNow: "Sign In Now",
    dontHaveAnAccount: "Doesn't have an account?",
    haveAnAccount: "I have an account with EMED4U?",
    forgottenPassword: "Forgotten Password?",
    emailAddress: "Email Address",
    password: "Password",
    createAccount: "Create your account",
    createOwnAccount: "I want to create my account as....",
    proceed: "Proceed",
    fullName: "Full name",
    confirmPassword: "Confirm password",
    alreadyAccount: "Already have an account?",
    login: "Log In",
    proceed: "Proceed",
    normalUser: "Normal User",
    doctor: "Doctor",
    clinic: "Clinicians / Hospitals",
    subAdmin: "Organization Sub-Admin",
    orgName: "Clinic name, organisation and practioner",
    address: "Address",
    country: "Country",
    or: "OR",
    home: "Home",
    homeHeadingText: "All your health parameters along with real time ECG at one place",
    appointments: "Appointments",
    today: "Today",
    upcoming: "Upcoming",
    viewMore: "View More",
    healthParameter: "Health Parameters",
    timeline: "Timeline",
    viewHealthParameter: "View health parameters",
    lipidProfile: "Lipid Profile",
    signUpLogin: "Login",
    weight:'Weight(Kg)',
    height:"Height(CM)",
    bmi:"bmi",
    weeklyAnalysis:"View weekly health analysis",
    addFullLipidProfile:"Add full lipid profile",
    health: "Health",
    sugarLevel: "Enter Blood sugar(mg/dL)",
    note: "Enter any note(Optional)",
    save: "Save",
    readingType: "Select reading type",
    bloodSugar: "Blood Sugar",
    respiratoryRate: "Respiratory Rate",
    breathPerMin: "Enter Breaths per min",
    heartRate: "Heart Rate",
    pulsePerMin: "Enter Pulse per min",
    bodyPart: "Select body part",
    bloodOxygen: "Blood Oxygen",
    readingMethod: "Select reading method",
    spo2Per: "Enter SPO2 percentage",
    bodyTemp: "Body Temperature",
    enterTemp: "Enter body temperature",
    selectScale: "Select scale",
    bloodPressure: "Blood Pressure",
    systolic: "Enter Systolic (mmHg)",
    diastolic: "Enter Diastolic (mmHg)",
    triglycerides: "Enter Triglycerides",
    cholesterol: "Enter Cholestrol",
    ldlc: "Enter LDL_C",
    vldl: "Enter VLDL",
    hdlc: "Enter HDL-C",
    appointments: 'Appointments',
    appointmentsSecondary: 'An aggregated view of all your scheduled & previous appointments.',
    healthConditions: 'Health Conditions',
    medications: 'Medications',
    surguries: 'Surguries',
    allergies: 'Allergies',
    vaccianations: 'Vaccinations',
    enterDignosis: 'Enter Diagnosis',
    treatedBy: 'Condition Treated By ?',
    homeHeadingText1: "All of your Paitents IPD and OPD View in one place",
    opd: "Out Paitent Department (OPD)",
    patientListing: "Patient Listing",
    ipd: "In Patient Department (IPD)",
    upgradeToPlan: "Upgrade to the full plan",
    addPatient: "Add Patient",
    manually : "Manually",
    patientId: "Patient ID",
    patientFullName: "Enter patient's name ",
    patientEmail: "Enter patient email",
    selectGender: "Select gender",
    bloodGroup: "Select blood group",
    contactNumber: "Enter contact number",
    enterCity: "Enter City",
    occupation: "Enter occupation",
    patientFullAddress: "Enter patient full address",
    add: "Add",
    enterPatientId: "Enter Patient ID",
    continue: "Continue",
    congratulations: "Congratulations",
    selectDepartment: "Select Department",
    selectBoth:"(you can select both)",
    selectRange: "Select practictioner range",
    completed: "Completed",
    enterPatientId: "Enter Patient ID",
    appointmentsOpd: "Appointments OPD",
    appointmentOpdHeading: "All scheduled appointments with day & weekly overview",
    generateQRinfo: "This will convert the selected features into a QR code for easy sharing & QR will be valid till selected time interval.",
    acknowledgement: "Yes I acknowledge to share my details with Emed4u.",
    billingAndInvoice: "Billing & Invoice",
    billingContent: "All invoice and billing data in one place",
    bookAppointment: "Book an Appointment",
    appointmentDetails: "Appointment details",
    patientInputs: "Patient Inputs",
    appointmentCheckout: "Appointment checkout",
    doctorList: 'Doctor\'s List',
    age: 'Enter age',
    Enterweight: 'Enter weight ',
    schedule: "Schedule",
    scheduleHeading: "All scheduled appointments with day & weekly overview",
    onlineAppointment: "Online Appointments",
    inclinicAppointment: "In Clinic Appointments",
    createSlot: "Create Slot",
    searchByDoctorName: "Search by doctor name, specialisation",
    searchByPatientName: "Search by  patient name",
    patientInformation: "Patient Information",
    doctorInformation: "Doctor Information",
    subadminInformation: "Sub-Adminstration Information",
    message: "Messages",
    medicalHistory: "Medical History",
    reportsPrescription: "Reports & E-Prescription",
    previousAppointment: "Previous Appointments",
    hideDetail: "Hide Details",
    viewDetail: "View Details",
    personalInformation: "Previous Appointments with medication",
    prevReports: "Previous Reports",
    prevPrescription: "Previous E-Prescription",
    noReportsAvailable: "No Reports available",
    noPrescriptionAvailable: "No Prescription available",
    showMore: "Show More",
    showLess: "Show Less",
    call: "Call",
    loading: "Loading......",
    sendMedication: "Send Medication",
    diagnosisAndObeservation : "Diagnosis and observation",
    enterDiagnosisObservation: "Enter Diagnosis and observation",
    formOfMedication: " Select form of medication",
    enterMedicationName: "Enter medication name",
    enterMedicineStrength: "Enter medicine Strength",
    enterStrengthType: "Enter Strength type",
    selectDosageIntake: "Select dosage quantity intake",
    addMoreModication: "Add More Medication",
    otherInstruction: "Other Instructions",
    enterNoteToPatient: "Enter note to patient eg: take medicine 30 mins before meal.",
    settlePayment: "Settle payment (if any pending amount)",
    enterPendingPayment: "Enter any pending payment left from patient side",
    sendFinalPayment: "Send final report to patient",
    notNow: "Not now",
    addMoreMedication: "Add more medication",
    cancel: "Cancel",
    noAppointmentAvailable: "No appointments available",
    npPrescriptionAvailable: "No prescription available",
    noInvoiceAvailable: "No invoice available",
    uploadFile: "Upload File ( File size must be less than 10mb ) ",
    bookAgain: "Book again",
    uploadFile: "Upload File",
    doctorsProfile: "Doctor’s Profile",
    doctorName: "Enter Doctor Name",
    selectAddress: "Enter Address",
    enterCurrentPassword: "Enter current password",
    enterNewPassword: "Enter new password",
    enterConfirmPassword: "Enter confirm password",
    opdIpdList: 'All patient into IPD and OPD will be here at one place',
    searchByPatNameDocName: 'Search by  patient name  , Doctor name ',
    backToAppointment: 'Back to Appointment List',
    opdList: 'All scheduled appointments with day & weekly overview',
    appointmentsIPD: 'Appointments IPD',
    sendActivationLink : 'Send Activation Link',
    appointmentSummary: 'Appointment Booking Summary',
    patientEmergencyContact: "Patient's Emergency Contact",
    patient: 'Patient',
    totalPatient: 'Total Patients: ',
    doctorIpdOpd: 'All doctors into IPD and OPD will be here at one place',
    addDoctor: 'Add Doctor',
    totalDoctor: 'Total Doctors: ',
    subAdmin: 'Sub-Administration',
    subAdminIpdOpd: 'All sub-admin into IPD and OPD will be here at one place',
    addSubAdmin: 'Add Sub-Administrator',
    totalSubAdmin: 'Total sub-admin',
    searchBySubAdmin: 'Search by name ',
    selectPermission: 'Select Permission',
    selectStatus: 'Select Status',
    doctorFullname: 'Enter Doctor full name',
    doctorEmail: 'Enter Doctor email',
    selectExp: 'Enter Experience',
    selectDegree: 'Select Degree',
    selectLanguage: 'Select Language',
    enterFullname: 'Enter full name',
    selectDesignation: 'Select Designation',
    noList : 'No list available',
    orgProfile: 'Organisation’s Profile',
    orgName: 'Enter organization name',
    ownerName: 'Enter Owner name',
    subadminProfile: "Sub-admin Profile",
    enterSubadminName: "Enter sub-admin's name",
    subadminEmail: "Enter sub-admin's email" ,
    searchPatient: "Search by Patient’s name, Id",
    searchDoc: "Search by Doctor’s name, Id",
    viewPatient: 'View Patient’s list',
    viewDoctor : 'View Doctor’s list',
    roomView : 'Room View',
    roomDescription: 'All rooms availability with day and week overview',
    backToIpd: 'Back to Patient IPD list',
    serviceList: 'Service Listing',
    prevIPD: 'Previous Ipd',
    dateOfObservation: 'Date of observation',
    patientDetails: 'Patient Details',
    editRoom: 'Edit room',
    addRoom: 'Add room',
    roomNumber: 'Room Number',
    selectType: 'Select room type',
    availability: 'Availability',
    done: 'Done',
    diagonosis: 'Provisional Diagnosis',
    illness: 'Present illness summary...',
    duration: 'Duration',
    comment: 'Comment',
    personalInfo: "Personal Information",
    patientMedical: 'Patient Medical Details',
    patientMedHistory: 'Patient Medical History',   
    selectTime: 'Select time interval',
    selectDesignation: 'Select Designation',
    patientUniqueId:"Patient's UniqueId",
    // Shop
    shop: "Shop",
    shopHeadingText: "Order health monitoring devices and accessories, delivered to your door",
    searchProducts: "Search products",
    noProductsAvailable: "No products available",
    viewProduct: "View",
    addToCart: "Add to cart",
    outOfStock: "Out of stock",
    cart: "Cart",
    yourCart: "Your cart",
    cartEmpty: "Your cart is empty",
    continueShopping: "Continue shopping",
    quantity: "Quantity",
    subtotal: "Subtotal",
    checkoutNote: "Taxes and shipping are calculated at checkout. You will be taken to our secure payment page.",
    proceedToCheckout: "Proceed to checkout",
    redirectingToCheckout: "Taking you to secure checkout...",
    remove: "Remove",
    loadMore: "Load more",
    viewDetails: "View details",
    buyNow: "Buy now",
    off: "off",
    inclusiveOfTaxes: "Inclusive of all taxes",
    productDetails: "Product details",
    deliveryEstimateNote: "Standard delivery in 3 to 5 business days",
    cartActionFailed: "Could not update your cart. Please try again.",
    productNotFound: "This product is no longer available.",
    myOrders: "My Orders",
    myOrdersHeadingText: "Track your device orders, shipments and refunds",
    noOrdersAvailable: "You have not placed any orders yet",
    ordersMatchedByEmail: "Orders are matched to the email address you use at checkout.",
    estimatedDelivery: "Estimated delivery",
    viewOrder: "View order",
    stepOrdered: "Ordered",
    stepShipped: "Shipped",
    stepDelivered: "Delivered",
    ordersNeedEmail: "Add an email address to your profile to see your orders here.",
    orderPlacedSuccess: "Thank you! Your order has been placed. It will appear here once payment is confirmed.",
    orderDetails: "Order details",
    orderNumber: "Order",
    orderDate: "Date",
    items: "Items",
    total: "Total",
    status: "Status",
    shippingAddress: "Shipping address",
    tracking: "Tracking",
    trackShipment: "Track shipment",
    backToOrders: "Back to orders",
    backToShop: "Back to shop",
    orderTimeline: "Order timeline",
    refunds: "Refunds",
    requestReturn: "Request return",
    refresh: "Refresh",
    tryAgain: "Try again",
    showingOrdersFor: "Showing orders placed with",
    returnItemsTitle: "What are you sending back?",
    returnNothingLeft: "There is nothing left to return on this order.",
    returnItemsLoading: "Checking what can be returned...",
    returnSelectOne: "Select at least one item.",
    returnDialogTitle: "Request a return",
    returnDialogText: "Tell us why you are returning this order. Our team will review the request and get back to you.",
    returnReason: "Reason",
    returnNote: "Anything else we should know? (optional)",
    returnSubmit: "Send request",
    returnSuccess: "Return requested. Our team will review it and contact you.",
    returnFailed: "We could not raise the return. Please try again or contact support.",
    orderCancelled: "Cancelled",
    orderCancelledOn: "Order cancelled on",
    shipmentStopped: "This shipment was stopped and is on its way back. Our team will contact you about a replacement or refund.",
    shopUnavailable: "The shop is not available right now. Please try again later.",

    // ---- Pre-orders ----
    backToHome: "Back to home",
    preorder: "Pre-order",
    preorderProgress: "Pre-order progress",
    stepChooseDevice: "Choose your device",
    stepCreateAccount: "Create your account",
    stepConfirmEmail: "Confirm your email",
    preorderHeading: "Reserve yours before it ships",
    preorderNotAvailable: "This pre-order is not available right now.",
    preorderClosed: "This pre-order has closed.",
    preorderSoldOut: "Sold out",
    choosePreorderProduct: "Choose a device",
    preorderInStock: "Available to pre-order",
    expectedDispatch: "Expected dispatch",
    dispatchEstimateNote: "This is an estimate, not a guaranteed delivery date. If it moves materially we will tell you and you can cancel for a full refund.",
    choosePaymentOption: "Choose how you would like to pay",
    noPaymentToday: "No payment today",
    noPaymentTodayNote: "Reserve your unit now and pay nothing. We will ask for payment once your device is ready, and it ships as soon as that payment clears.",
    paymentCollectedBefore: "Payment is collected before dispatch",
    paymentWillBeRequested: "We will ask you to pay around",
    paymentDueNow: "Payment is now due",
    payEarly: "Pay early",
    payEarlyNote: "You do not have to pay yet. You can if you would rather get it out of the way.",
    paymentNotOpenYet: "Payment is not open yet — we will email you when it is.",
    actionsNotOpenYet: "This pre-order is read-only for now. We will email you when there is something to do.",
    reserveYourUnit: "Reserve your unit",
    nothingToPayNow: "Nothing to pay now",
    reservedNoPaymentNote: "Your unit is reserved. We will email you when it is ready to pay for.",
    payBeforeDispatchNote: "Your device ships once this payment clears.",
    payInFull: "Pay in full",
    payDeposit: "Pay a deposit",
    reserveNow: "Reserve now, pay later",
    payInFullNote: "Pay everything today and save",
    payDepositNote: "Pay part today, the rest when it is ready to ship",
    reserveNowNote: "Nothing to pay today. We will ask for payment when stock is ready",
    dueToday: "Due today",
    dueLater: "Due later",
    youSave: "You save",
    continueToCheckout: "Continue",
    preorderNow: "Pre-order now",
    deliveryAddress: "Delivery address",
    addressNotSetYet: "Not added yet",
    addressNeededBeforeDispatch: "Add your delivery address before this ships. You can change it any time until it is dispatched.",
    addAddress: "Add address",
    changeAddress: "Change",
    saveAddress: "Save address",
    addressSaved: "Delivery address saved.",
    deliveringTo: "Delivering to",
    addressLine1: "Flat, house, street",
    addressLine2: "Area, landmark (optional)",
    city: "City",
    state: "State",
    pincode: "Pincode",
    agreementsHeading: "Before you continue",
    acceptAllToContinue: "Please accept all three to continue.",
    requiredConsent: "Required",
    optionalConsent: "Optional",
    readFullText: "Read the full text",
    openFullPage: "Open the full page on emed4u.com",
    close: "Close",
    versionLabel: "Version",
    placePreorder: "Place pre-order",
    continueToCreateAccount: "Continue",
    accountNeededNote: "Next you will create your account. Your details are saved — we place the pre-order as soon as you activate it.",
    signInToContinue: "Sign in to continue",
    accountActivated: "✓ Your account is activated",
    signingYouIn: "Signing you in...",
    activationLinkExpired: "This activation link has already been used",
    activationLinkExpiredNote: "Your account is active. Please sign in to continue your pre-order.",
    accountActivatedNote: "Sign in to finish your pre-order — your selection is saved.",
    preorderSignIn: "Sign in to complete your pre-order",
    preorderCreateAccount: "Create your account to pre-order",
    confirmYourEmail: "Confirm your email",
    confirmYourEmailNote: "One step left — enter the code we just sent you and your pre-order is placed.",
    enterTheCode: "Enter the 6-digit code",
    codeSentTo: "We sent it to",
    codeExpiryNote: "It is valid for 10 minutes.",
    confirmAndContinue: "Confirm and continue",
    resendCode: "Send a new code",
    resendIn: "You can ask for a new code in",
    codeResent: "A new code is on its way.",
    useAnotherEmail: "Use a different email",
    signInToPreorderNote: "Your selection is saved. Sign in or create an account and you will come straight back here.",
    myPreorders: "My pre-orders",
    myPreordersHeadingText: "Devices you have reserved, and what happens next",
    noPreordersNote: "When you reserve a device it will appear here, with its dispatch window and what is left to pay.",
    noPreorders: "You have not placed any pre-orders yet.",
    orderNumber: "Order number",
    paidSoFar: "Paid so far",
    stillDue: "Still due",
    paymentSchedule: "Payment schedule",
    instalment: "Instalment",
    amount: "Amount",
    dueDate: "Due",
    keepPreorder: "Keep it",
    payNow: "Pay now",
    cancelPreorder: "Cancel pre-order",
    cancelPreorderConfirm: "Cancel this pre-order? Anything you have paid will be refunded to the original payment method.",
    cancelReasonLabel: "Reason (optional)",
    preorderPlaced: "Your pre-order is confirmed.",
    preorderPlacedTitle: "Pre-order placed",
    preorderPlacedNote: "Your unit is reserved. Nothing has been charged — we will email you when it is ready to pay for.",
    viewMyPreorders: "View my pre-orders",
    preorderReserved: "Your pre-order is reserved.",
    preorderCancelled: "Your pre-order has been cancelled.",
    preorderPayFailed: "We could not take that payment. Nothing has been charged.",
    preorderGenericError: "Something went wrong. Please try again.",
    reservationHeldNote: "We are holding your unit while you pay.",
    viewPreorder: "View pre-order",

    // ---- Pre-order product page ----
    openForPreorder: "Open for pre-order",
    limitedFirstBatch: "Limited first batch",
    decreaseQuantity: "Decrease quantity",
    increaseQuantity: "Increase quantity",
    secureCheckout: "Secure checkout",
    oneYearWarranty: "1-year warranty",
    freeDelivery: "Free delivery",
    cancelBeforePaying: "Cancel before you pay",
    whyPreorderTitle: "Why reserve one now",
    whyPreorderNote: "A reservation costs nothing today and holds a unit from the first batch in your name.",
    builtDifferentTitle: "Built different",
    builtDifferentNote: "What sets this device apart from the trackers you have already tried.",
    loadingProduct: "Loading this device",
    backToTop: "Back to top",
    closerLookTitle: "A closer look",
    closerLookNote: "What gets measured, and how the readings look in the Emed4u app.",
    productLoopLabel: "A few seconds of the device in use, without sound",
    pauseVideo: "Pause video",
    playVideo: "Play video",
    faqTitle: "Questions, answered",
    faqNote: "The things people ask before reserving. Anything else, our team is a message away.",
    photoComingSoon: "Product photography is on its way",

    // ---- Pre-order packages ----
    packageContentsTitle: "What's in the package",
    packageContentsNote: "Two devices, one reservation and one delivery.",
    whyPackageTitle: "Why take both",
    boughtSeparately: "Bought separately",
    youSaveAmount: "You save",
    viewThisDevice: "View this device",
    alsoInPackageTitle: "Also sold as a package",
    seeThePackage: "See the package",
    recommendedTag: "Recommended",
}